(() => {
  const instances = new Map();

  function initSlider(section) {
    const slider = section.querySelector(".kopi-roasters-slider");

    if (!slider) return;

    if (instances.has(section.id)) {
      instances.get(section.id).destroy(true, true);
    }

    let swiper;

    function createDesktop() {
      return new Swiper(slider, {
        speed: 500,

        slidesPerView: "auto",

        centeredSlides: true,

        spaceBetween: 52,

        slideToClickedSlide: true,

        grabCursor: true,

        watchSlidesProgress: true,

        observer: true,
        observeParents: true,

        on: {
          init(swiper) {
            updateCenter(swiper);
          },

          slideChange(swiper) {
            updateCenter(swiper);
          },

          transitionEnd(swiper) {
            updateCenter(swiper);
          }
        }
      });
    }

    function createMobile() {
      return new Swiper(slider, {
        speed: 500,

        effect: "cards",

        grabCursor: true,

        cardsEffect: {
          slideShadows: false,
          rotate: false,
          perSlideRotate: 0,
          perSlideOffset: 10
        }
      });
    }

    function updateCenter(swiper) {
      swiper.slides.forEach((slide) => {
        slide.classList.remove("is-center");
      });

      if (swiper.slides[swiper.activeIndex]) {
        swiper.slides[swiper.activeIndex].classList.add("is-center");
      }
    }

    function init() {
      if (window.innerWidth <= 768) {
        swiper = createMobile();
      } else {
        swiper = createDesktop();
      }

      instances.set(section.id, swiper);
    }

    init();

    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        const mobile = window.innerWidth <= 768;
        const usingCards = swiper.params.effect === "cards";

        if ((mobile && !usingCards) || (!mobile && usingCards)) {
          swiper.destroy(true, true);

          init();
        }
      }, 200);
    });
  }

  function initAll() {
    document
      .querySelectorAll(".kopi-roasters")
      .forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSlider(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const id = event.target.id;

    if (!instances.has(id)) return;

    instances.get(id).destroy(true, true);

    instances.delete(id);
  });

})();